import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3"
}
const _hoisted_2 = { class: "box has-background-black has-text-centered" }
const _hoisted_3 = { class: "title has-text-white has-text-weight-bold" }
const _hoisted_4 = {
  class: "box has-background-light has-text-centered",
  style: {
        textTransform: 'capitalize',
      }
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Your role", -1)
const _hoisted_6 = {
  key: 0,
  class: "title has-text-weight-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "title has-text-weight-bold"
}
const _hoisted_8 = {
  key: 0,
  class: "box has-background-light"
}
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "tag is-success is-normal ml-2"
}
const _hoisted_11 = {
  key: 1,
  class: "tag is-dark is-normal ml-2"
}
const _hoisted_12 = {
  key: 2,
  class: "tag is-warning is-normal ml-2"
}
const _hoisted_13 = {
  key: 3,
  class: "tag is-info is-normal ml-2"
}
const _hoisted_14 = {
  key: 4,
  class: "tag is-link is-normal ml-2"
}
const _hoisted_15 = {
  key: 5,
  class: "tag is-black is-normal ml-2"
}
const _hoisted_16 = {
  key: 6,
  class: "tag is-light is-normal ml-2"
}
const _hoisted_17 = {
  key: 7,
  class: "tag is-danger is-normal ml-2"
}
const _hoisted_18 = {
  key: 1,
  class: "box has-background-light"
}
const _hoisted_19 = {
  key: 0,
  class: "tag is-info is-normal ml-2"
}
const _hoisted_20 = {
  key: 1,
  class: "tag is-danger is-normal ml-2"
}
const _hoisted_21 = {
  key: 2,
  class: "tag is-light is-normal ml-2"
}
const _hoisted_22 = {
  key: 3,
  class: "tag is-black is-normal ml-2"
}
const _hoisted_23 = {
  key: 4,
  class: "tag is-primary is-normal ml-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-bold" }, " Next ", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  class: "columns py-4 is-centered is-mobile"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_28 = { class: "column is-half has-text-centered" }
const _hoisted_29 = { class: "checkbox" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_31 = {
  class: "modal",
  id: "actionsModal"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "modal-content px-5"
}
const _hoisted_34 = { class: "box" }
const _hoisted_35 = { class: "title is-4 has-text-centered has-text-weight-bold" }
const _hoisted_36 = {
  class: "title is-5 has-text-centered has-text-weight-light",
  style: {"text-transform":"capitalize"}
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.gameData && _ctx.myData.role)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.steps[_ctx.gameData.step]), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.myData.role == 'mdrtr')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.myData.role), 1))
              : (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(_ctx.showRole ? _ctx.myData.role : "*****"), 1))
          ]),
          (_ctx.myData.role == 'mdrtr')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameData.players, (player, i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(`button is-fullwidth ${
          i + 1 != _ctx.gameData.players.length ? 'mb-2' : ''
        }`),
                    key: player.pid,
                    disabled: player.role == 'mdrtr',
                    onClick: ($event: any) => (_ctx.openActionsModal(player.pid))
                  }, [
                    _createTextVNode(_toDisplayString(player.name) + " ", 1),
                    (player.pid == _ctx.myData.pid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " You "))
                      : _createCommentVNode("", true),
                    (player.role == 'mdrtr')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Mdrtr "))
                      : _createCommentVNode("", true),
                    (player.role == 'seer')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Seer "))
                      : _createCommentVNode("", true),
                    (player.role == 'dr')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Dr "))
                      : _createCommentVNode("", true),
                    (player.role == 'drnk')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Drnk "))
                      : _createCommentVNode("", true),
                    (player.role == 'wrwlf')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Wrwlf "))
                      : _createCommentVNode("", true),
                    (player.role != 'wrwlf' && player.role != 'mdrtr')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Vllgr "))
                      : _createCommentVNode("", true),
                    (!player.isAlive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Dead "))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_9))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameData.players, (player, i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(`button is-fullwidth ${
          i + 1 != _ctx.gameData.players.length ? 'mb-2' : ''
        }`),
                    key: player.pid,
                    disabled: ""
                  }, [
                    _createTextVNode(_toDisplayString(player.name) + " ", 1),
                    (player.pid == _ctx.myData.pid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " You "))
                      : _createCommentVNode("", true),
                    (!player.isAlive && _ctx.gameData.step == 'day')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Dead "))
                      : _createCommentVNode("", true),
                    (
            _ctx.gameData.step == 'seer' && player.reveal && _ctx.myData.role == 'seer'
          )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(player.role == "wrwlf" ? "Wrwlf" : "Vllgr"), 1))
                      : _createCommentVNode("", true),
                    (player.role == 'mdrtr')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Mdrtr "))
                      : _createCommentVNode("", true),
                    (
            player.role == 'wrwlf' &&
            _ctx.myData.role == 'wrwlf' &&
            _ctx.gameData.step == 'wrwlf'
          )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Wrwlf "))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ])),
          (_ctx.myData.role == 'mdrtr')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "button is-dark is-fullwidth",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateGameStep && _ctx.updateGameStep(...args)))
              }, _hoisted_25))
            : _createCommentVNode("", true),
          (_ctx.myData.role != 'mdrtr')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showRole) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.showRole]
                    ]),
                    _createTextVNode(" Show my role ")
                  ])
                ]),
                _hoisted_30
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      (_ctx.selectedPlayer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.selectedPlayer.name), 1),
              _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.selectedPlayer.role), 1),
              _createElementVNode("button", {
                class: "button is-danger has-text-weight-bold is-fullwidth mb-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modifyPlayer('kill'))),
                disabled: 
            (_ctx.gameData.step != 'wrwlf' && _ctx.gameData.step != 'day') ||
            !_ctx.selectedPlayer.isAlive
          
              }, " Kill ", 8, _hoisted_37),
              _createElementVNode("button", {
                class: "button is-info has-text-weight-bold is-fullwidth mb-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modifyPlayer('heal'))),
                disabled: _ctx.gameData.step != 'dr'
              }, " Heal ", 8, _hoisted_38),
              _createElementVNode("button", {
                class: "button is-warning has-text-weight-bold is-fullwidth",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modifyPlayer('reveal'))),
                disabled: _ctx.gameData.step != 'seer'
              }, " Reveal to seer ", 8, _hoisted_39)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "modal-close is-large",
        "aria-label": "close",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeActionsModal && _ctx.closeActionsModal(...args)))
      })
    ])
  ], 64))
}